import { Box, Button, Container, List, Paper, Tab, Tabs } from '@mui/material';
import { Subheader, TabPanel } from 'components';
import useAcademies from 'hooks/useAcadamies';
import { use, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AcademyDetails from './AcademyDetails';
import { useAcademyEvents, useNavigation } from 'hooks';
import EventsScrollableList from './EventsScrollableList';
import EventListItem from './EventListItem';
import { Add } from '@mui/icons-material';
import SubmissionsList from './submissions/SubmissionsList';

const CREATE_BUTTON_CONFIG = [
	{
		url: 'academies',
		title: 'Academy'
	},
	{
		url: 'events',
		title: 'Event'
	},
	{
		url: 'submissions',
		title: 'Submissions'
	}
];

const AcademyShow = () => {
	const [tabValue, setTabValue] = useState(0);
	const [createConfig, setCreateConfig] = useState(CREATE_BUTTON_CONFIG[0]);
	const { id } = useParams();
	const {
		findAcademy,
		academy,
		isLoading,
		resortAcademyEvents,
		regenerateInvitationCode
	} = useAcademies({});
	const {
		findAcademyEvents,
		academyEvents,
		setAcademyEvents,
		deleteAcademyEvent
	} = useAcademyEvents({});

	const { handleEditClick } = useNavigation({
		history,
		url: '/academies'
	});
	const navigate = useNavigate();

	const handleDeleteClick = (event) => {
		deleteAcademyEvent(event);
		setAcademyEvents((prevEvents) =>
			prevEvents.filter((e) => e.id !== event.id)
		);
	};

	const handleTabChange = (_, newValue) => {
		setTabValue(newValue);
		setCreateConfig(CREATE_BUTTON_CONFIG[newValue]);
	};

	const handleShowAcademyEvent = (event) => {
		navigate(`/academy/events/${event.id}`);
	};

	const handleEditAcademyEvent = (event) => {
		navigate(`/academies/${academy.id}/event/${event.id}/edit`);
	};

	const handleOnDragEnd = (result) => {
		setAcademyEvents(result);
		resortAcademyEvents(result);
	};

	const handleOnEditClick = () => {
		handleEditClick(academy);
	};

	const handleRegenerateInvitationCode = async () => {
		regenerateInvitationCode();
	};

	useEffect(() => {
		if (id) findAcademy(id);
	}, [id]);

	useEffect(() => {
		if (id) findAcademyEvents({ academy_id: id });
	}, [id]);

	const createButton = useMemo(() => {
		return createConfig.url === 'academies' ? (
			<Button color="primary" variant="contained" onClick={handleOnEditClick}>
				Edit {createConfig.title}
			</Button>
		) : (
			<Button
				color="primary"
				variant="contained"
				onClick={() => navigate('event/new')}
			>
				<Add />
				Add Event
			</Button>
		);
	}, [createConfig, academy]);

	return (
		<>
			<Subheader
				title={isLoading ? 'Loading...' : academy.title}
				buttons={[createButton]}
			/>
			<Container>
				<Tabs
					value={tabValue}
					onChange={handleTabChange}
					aria-label="Academy Details"
				>
					<Tab label="Academy" />
					<Tab label="Events" />
					<Tab label="Submissions" />
				</Tabs>
				<Paper>
					<TabPanel value={tabValue} index={0}>
						<AcademyDetails
							academy={academy}
							regenerateInvitationCode={handleRegenerateInvitationCode}
						/>
					</TabPanel>
					<TabPanel value={tabValue} index={1}>
						<EventsScrollableList
							id="events-scrollable-list"
							list={academyEvents}
							ListContainer={List}
							onDragEnd={handleOnDragEnd}
							ListItem={({ item, index }) => (
								<EventListItem
									event={item}
									index={index}
									handleDeleteClick={handleDeleteClick}
									handleEditClick={handleEditAcademyEvent}
									handleShowAcademyEvent={handleShowAcademyEvent}
								/>
							)}
						/>
					</TabPanel>
					<TabPanel value={tabValue} index={2}>
						<SubmissionsList tabValue={tabValue} />
					</TabPanel>
				</Paper>
			</Container>
		</>
	);
};

export default AcademyShow;
